import { Link, Navigate } from "react-router-dom";
import AdminShell from "../components/AdminShell";

const REPORT_CARDS = [
  {
    to: "/admin/reports/new-users",
    title: "New users",
    description: "Daily sign-ups — total, hiring managers, and applicants.",
  },
];

export default function AdminReportsPage({ currentUser, onSignOut }) {
  if (currentUser?.role !== "admin") {
    return <Navigate to="/admin/signin" replace />;
  }

  return (
    <AdminShell currentUser={currentUser} onSignOut={onSignOut}>
      <Link to="/admin" className="jw-admin__back">
        ← Back to home
      </Link>
      <h1 className="jw-admin__title">Reports</h1>
      <p className="jw-admin__lede">Platform metrics for ops.</p>

      <div className="jw-admin-hub">
        {REPORT_CARDS.map((card) => (
          <Link key={card.to} to={card.to} className="jw-admin-hub-card">
            <h2 className="jw-admin-hub-card__title">{card.title}</h2>
            <p className="jw-admin-hub-card__desc">{card.description}</p>
            <span className="jw-admin-hub-card__cta">Open report</span>
          </Link>
        ))}
      </div>
    </AdminShell>
  );
}
